export const settingsEn = {
  pageTitle: "Settings",
  pageSubtitle: "Manage merchant settings and PowerBI report mappings.",
  createWorkspace: "Create Workspace",
  language: "Language",
  loading: "Loading settings...",
  loadFailed: "Failed to load settings...",
  enabled: "Enabled",
  disabled: "Disabled",
  notSet: "Not set",
  createWorkspaceFirst: "Create workspace first",
  missingReport: "Missing report ({{value}})",
  jdaBaselineImport: "JDA Baseline Import",
  toasts: {
    saved: "Settings changes have been saved!",
    workspaceCreated: "PowerBI workspace has been created!",
  },
  booleanSettings: {
    productRanking: {
      label: "Product Ranking",
      description: "Enable the product ranking controls used in merchflow workflows.",
    },
    maxUnits: {
      label: "Max Units",
      description: "Enable max-units behavior where supported in planning flows.",
    },
    spaceMix: {
      label: "Space Mix",
      description: "Expose space mix functionality in the merchflow experience.",
    },
    dosPercentage: {
      label: "Display DOS as Percentage",
      description: "Show days of supply using percentage formatting.",
    },
    jdaImport: {
      label: "JDA Baseline Import",
      description: "Show the JDA baseline import action used for retailer-provided data exports.",
    },
    shelfWeight: {
      label: "Shelf Weight",
      description:
        "Send product weights to the optimizer, enable the weight rules tab, and show shelf load and overload on planograms.",
    },
    excludeSlowMovers: {
      label: "Leave Slow Movers Out by Default",
      description:
        'Open the planogram rules with "Leave slow movers out of the planogram?" switched on. Planners can still switch it off for a run.',
    },
  },
  reportSettings: {
    basePog: {
      label: "Base POG Report",
      description: "Used by the base POG report entry point.",
    },
    storePog: {
      label: "Store POG Report",
      description: "Used by the all-stores integrity report entry point.",
    },
    singleStorePog: {
      label: "Single Store POG Report",
      description: "Used by the single-store integrity report entry point.",
    },
    categoryRangeReview: {
      label: "Category Range Review Report",
      description: "Used by the category range review report entry point.",
    },
  },
} as const;

export type SettingsTranslations = typeof settingsEn;
